
export default {
  name: 'AppIconCoachMarkMobile',
  props: {
    iconSize: { type: Number, default: null }
  }
};
